var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 222,
    viewBox: "0 0 301 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.607 121.607C302.464 115.749 302.464 106.251 296.607 100.393L201.147 4.93398C195.289 -0.923881 185.792 -0.923881 179.934 4.93398C174.076 10.7918 174.076 20.2893 179.934 26.1472L264.787 111L179.934 195.853C174.076 201.711 174.076 211.208 179.934 217.066C185.792 222.924 195.289 222.924 201.147 217.066L296.607 121.607ZM-1.01161e-08 126L286 126L286 96L1.01161e-08 96L-1.01161e-08 126Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bb90fe7e2d291857a7f3856fcadc4012.svg";
export { ForwardRef as ReactComponent };